<script>
export default {
  methods: {
    onClose() {
      this.$emit('close')
    },
  },
}
</script>
<template>
  <div :class="$style['modalWrapper']" style="width: auto">
    <header class="modal-card-head">
      <p
        class="modal-card-title"
      >{{ $t('global.TERMS_OF_SERVICE'/* i保庇 服務條款 */) }}</p>
      <div
        :class="$style['modalClose']"
        class="delete"
        @click="onClose"
      ></div>
    </header>
    <section class="modal-card-body sectionArticle">
      <p>歡迎使用DingSomething !</p>
      <p>訂購或使用白日夢創意國際有限公司(以下稱本公司或DingSomething)之服務或透過DingSomething購買任何服務前，您(以下稱您、買方或賣方(視情形)或用戶)應先審閱、瞭解及同意本服務條款，再於服務網頁上就本服務條款勾選表示同意，若您繼續使用本服務或與本服務有關之任何服務，即表示您已閱讀、瞭解並同意遵守本服務條款，並同意您任何使用本服務的行為均受本服務條款之管轄。</p>
      <ol class="isRowStyleA">
        <li>
          <p>本服務條款之適用範圍如下(以下稱本服務) :</p>
          <ul class="isRowStyleB">
            <li>a) DingSomething 網頁，包含前台、後台及本公司服務網址;</li>
            <li>b) DingSomething 應用程式服務;</li>
            <li>c) DingSomething 用來推廣服務之任何網站、應用程式服務或社群媒體; 及</li>
            <li>
              d)
              透過DingSomething或其相關服務所提供的所有資訊、連結網頁、功能、資料、文字、影像、相片、圖形、音樂、聲音、影片、訊息、標籤、內容、程式設計、軟體、應用程式服務 (包括但不限於任何行動應用服務)；
            </li>
          </ul>
          <p>任何本公司新增、變更或強化前述適用範圍之內容亦應受本服務條款之管轄。</p>
        </li>
        <li>
          <p>您同意並了解:</p>
          <p>本公司是一獨立於買賣方外之第三方，提供賣方(即提供實體服務之商家或個人)一雲端工具，讓買方得透過DingSomething購買賣家之服務或商品或透過DingSomething進行產品或服務之露出等加值服務。實際商品或服務之買賣合約或有關之法律行為(下稱實際交易)之權利義務僅存在於買方及賣方之間，本公司非該法律行為的主體，買賣雙方應單獨承擔有關其間實際交易權利義務之履行、服務刊登、購物擔保及類似事項之全部責任，與本公司無涉。若您有退款或變更前述實際交易內容之需求，或有任何商品活服務之問題請直接連繫賣方。</p>
        </li>
        <li>
          <p>您聲明與保證，或確保您合法授權之人已聲明與保證，在使用本服務前及使用本服務時均符合下列事項:</p>
          <ul class="isRowStyleC">
            <li>3.1 您是具備完全權利能力和行為能力之自然人、法人或其他組織或已經合法授權代表前述之人，並已接受本服務條款，且依法有權為之。若您不具備前述主體資格，您應於使用本服務前取得您法定代理人、監護人、輔助人或有權同意之人之同意，且您與前述之人應承擔違反聲明而導致之一切後果，且本公司有權向您及您的法定代理人求償；</li>
            <li>3.1 依照相關法規，您有權使用本服務，且使用本服務不違反您與任何他人之契約或約定；</li>
            <li>3.2 您提供用以支付本服務款項或支付買賣方交易款項之金融支付工具均為您合法有權使用，若日後有主張偽冒交易或有否認交易之情形，您應依照法律程序向警察機關報案並向提供您金融支付工具之金融業者按其程序提出相關證明後，若為本服務有關款項，通知本公司；若為其他交易款項，通知賣方。除契約另有約定外，本公司不具任何款項返還義務。若因您之故意或過失造成前述爭議，您同意無條件賠償本公司所受之損害。</li>
            <li>3.3 您負有妥善保管使用本服務所註冊之帳號、密碼、憑證或其他足以辨別身分之工具、購買證明或使用憑證之義務，不得以任何方式讓與或轉借他人使用。</li>
            <li>3.4 不為他人或為任何不法或未經本公司允許之目的使用本服務，亦不得使用本服務進行任何不正當或有損DingSomething商譽或信譽之活動，如違反任何應適用之法規，您將自行負擔相關法律責任；</li>
            <li>3.5 遵守中華民國相關法規及一切使用網際網路之國際慣例，且不得利用本服務從事任何侵害他人權益之行為；</li>
            <li>3.6 不得未經本公司合法授權，利用本公司或本服務之專有資訊或智慧財產權，亦不得移除、變更或隱蔽本公司或其供應商、合作夥伴、授權人顯示於本服務之資訊；</li>
            <li>3.7 不得修改、變更、翻譯本服務或自本服務改作出衍生著作，亦不得就本服務進行逆向工程、反編譯、反彙編或以其他方式試圖探究本服務之原始碼；</li>
            <li>3.8 不得利用網路或其他方式自行對外提供DingSomething之服務；</li>
            <li>3.9 除DingSomething提供之功能外，不得利用本服務寄發自動問卷或商業廣告；</li>
            <li>
              3.10
              不得於本服務使用或試圖使用網路蜘蛛或以機器人或其他技術方法，變更、刪除、破壞本服務之資料內容或設備，或是對本網站之經營造成不良影響包含造成基礎設備不成比例的大流量；
            </li>
            <li>3.11 不得上傳包含病毒、木馬程式或蠕蟲之任何資料；</li>
            <li>3.12 不得藉由本服務設計存在之漏洞，或以越過、破壞本服務有關網站安全維護機制等其他技術方法，變更、刪除或蒐集他人之個人資料；</li>
            <li>
              3.13
              您同意授權本公司蒐集、處理及利用您所提供之資料用以經營本服務或未來本公司提供之其他衍生服務，包含數據分析、個人興趣取向形象化(profiling)、行銷或推廣本服務或其他衍生服務。
            </li>
          </ul>
        </li>
        <li>您同意為使用本服務、第三方之服務或進行實質交易，本公司得將您的個人或商戶資料提供給金融服務提供商或為與您進行實質交易之相對方，若您不同意，請勿使用本服務。</li>
        <li>您了解本公司未提供任何金流代收服務，您若申請使用代收金流相關服務，您同意本公司得將您的申請資料提供給金流服務提供商或其他第三方服務提供商進行申請，前述提交申請動作本公司僅代您處理資訊流之傳遞，相關權利義務及費用等悉依金流服務提供商之契約或使用者規範為準，您須遵守該服務提供商所要求之相關規定。</li>
        <li>使用本服務時，您應選擇適合您的訂購方案，若有需變更訂購方案，本公司保留向您收取費用之權利。使用本服務約定之扣款日為您綁定金融工具之日及其後每月之相對日。若於次月無相對日，將往後延遲至下一個月1號扣款，之後之扣款日均調整為每月1號。</li>
        <li>本公司得提供使用本服務之優惠或行銷方案，包括推廣活動、行銷活動、折價券等，您同意配合本公司之優惠活動辦理，不得阻止用戶使用相關優惠。</li>
        <li>於使用本服務時，本公司得就用戶登入資訊（包括網路IP位置與時間）、所為之行為及其他依法令應留存之紀錄予以詳實記錄。</li>
        <li>若您於發現有疑似第三人冒用或盜用您持有之本服務帳號、密碼或憑證等資料，或其他任何未經合法授權之情形時，應立即通知並採取防範措施。</li>
        <li>您不得使用本服務從事法規禁止或各中央目的事業主管機關公告不得從事之交易。如您銷售或提供遞延性商品或服務，應依相關法規規定辦理履約保證或交付信託，並應揭露該履約保證或交付信託資訊予知悉。</li>
        <li>本公司保有不定期更新、修改與補充本服務條款之權利。您應定期審閱本服務有關服務條款之更新。若您不同意本服務條款之內容或不同意本公司得隨時修改之，或者您所屬的國家或地域排除本服務條款內容之全部或一部時，請您立即停止使用本服務。</li>
        <li>您不得移轉任何有關本服務之權利、利益或義務與其他第三人，惟本公司有權將所有權利、利益或義務移轉予他人。</li>
        <li>本服務所使用之軟體或程式、網站上所有內容，包括但不限於著作、圖片、檔案、資訊、料、網站架構、網站畫面的安排、網頁設計，均由本公司或其他權利人依法擁有其智慧財產權，包括但不限於商標權、專利權、著作權、營業秘密等。任何人不得逕自使用、修改、重製、公開播送、改作、散布、發行、公開發表、進行還原工程、解編或反向組譯。若您欲引用或轉載前述軟體、程式或網站內容，必須依法取得本網站或其他權利人的事前書面同意。</li>
        <li>本服務係依現況現狀提供您使用，本公司保留隨時修改各項服務功能之全部或一部之權利。本公司對於本服務不作任何明示、暗示或法定的擔保、主張或聲明，包括但不限於對於品質、效能、無侵權、適售性或特定用途適用性之擔保，或因交易過程、按慣例或行業常規而衍生之擔保。本公司亦不保證提供本服務或其所含功能可被存取、不會中斷、及時提供、安全可靠、正確、完整或無錯誤，亦不保證瑕疵（如有）會被更正；</li>
        <li>本公司不保證本服務及本服務網站伺服器完全沒有任何病毒、蠕蟲、軟體鎖、致死裝置、木馬、路由、陷阱門、定時炸彈或任何其他有害之程式碼、指令、程式或元件，本公司對於您使用或無法使用本服務而造成之損害及/獲損失均不負賠償責任，亦不負通知義務。</li>
        <li>本公司不保證本服務不會因任何第三方之行為（包括但不限於網路攻擊）而受到不利影響。本公司不擔保預見、防免、減輕該等第三方之行為，或對該等第三方之行為採取適當措施。</li>
        <li>如任何人含本公司因您使用本服務受有損害及/或損失，本公司概不負責。</li>
        <li>對於因您使用本服務或因您違反本服務條款，致使本公司遭受或發生之任何訴訟、賠償責任、訴訟費用、賠償請求、直接或間接之損失或損害等，您同意全額（包含律師費用）賠償本公司。</li>
        <li>本公司無義務對本服務上內容加以任何事先審查，對您或任何買賣方之使用行為亦無法進行全面控制，您使用本服務時，包括內容之正確性、完整性或實用性時，您同意將自行加以判斷並承擔所有風險。本公司無義務暫停或終止特定用戶使用本服務，但本公司有權自行判斷是否移除違反本服務條款或其他引起反感之任何內容，且您不得因此對本公司主張任何損害。</li>
        <li>
          <p>您瞭解並同意，本公司基於以下目的之合理必要範圍內，認定必須將本服務有關內容加以保存或揭露予政府機關、司法警察、未成年人之監護人及相關會員時，得逕自加以保存及揭露：</p>
          <ul class="isRowStyleB">
            <li>a) 為遵守法令或政府機關之要求。</li>
            <li>b) 為提供本服務所必須者。</li>
            <li>c) 為防止他人權益之重大危害而有必要者。</li>
            <li>d) 為免除用戶及公眾之生命、身體、自由、權利、財產上之急迫危險者。</li>
            <li>e) 其他 DingSomething認為有必要的情況。</li>
          </ul>
        </li>
        <li>本公司有權於任何時間暫時或永久修改或終止本服務之全部或一部，而無論其通知與否，您同意本公司對於本服務所作的任何修改、暫停或終止，對您和任何第三人均無需承擔任何責任。</li>
        <li>您承認在法律容許的最大限度內，您個人應承擔使用本服務或其效能之全部相關風險。</li>
        <li>本服務可能會提供第三方內容或連結至其他外部連結，您可能因此連結其他業者經營或銷售之網站，惟不代表本公司與該等業者有任何關係。本公司無義務確保該些連結將使您進入完全無風險之網站，該些網站可能涉及法律或其他實際風險，您應自行採取預防措施，以確保您選擇使用之網站並無病毒、惡意程式或其他類似程式等。</li>
        <li>本公司 不控制且不為第三方之內容與網站背書或保證其內容之正確性與完整性，亦不對第三方網站的內容、隱私政策與行為承擔責任。如您因使用或依賴任何此類網站或資源發布的或經由此類網站或資源獲得的任何內容、商品或服務所產生的任何損害或損失，概由您自行負責，本公司不負任何直接或間接之責任。</li>
        <li>於法律允許之最大範圍內， 本公司將不負責任何本服務所造成的損害、利益損失、收入損失、生意損失、機會損失、資料遺失、間接或是因果損失等。並且本公司對任何單一用戶之責任，將以本公司對該用戶所收取的費用為上限。</li>
        <li>基於不可抗力、法律或政策的變化或其他非本公司所能控制的因素，致 本公司不能履行本服務時，本公司可隨時停止提供相關的服務。</li>
        <li>本服務條款及任何其他的協議、告示或其他關於您使用本服務之通知，您同意DingSomething得使用電子文件為表示方法、得以電子方式通知或公告於本服務網站上等。您同意本公司以電子方式通知或公告之日即視為通知已送達。因資訊傳輸等原因導致您未在前述通知發出當日收到該等通知者，本公司不負擔任何責任。</li>
        <li>如本服務條款之任何條款被認定為違法、無效或不可執行，該等條款應視為具可分割性，不影響其他條款之有效性及可執行性。</li>
        <li>如本公司遲延或未履行依本服務條款之權利時，不構成對該等權利之拋棄。</li>
        <li>本公司於提供任何特定服務之公告、政策或執行規則均構成本服務條款之一部，並取代雙方先前之任何形式的合意、溝通或建議 (包括但不限於舊版服務條款)。</li>
        <li>您與本公司僅得以自己名義對他方提起主張與請求，不可為任何團體訴訟、代表訴訟、合併程序或包含多位聲請人之程序的當事人。</li>
        <li>本服務條款之效力、解釋、適用及爭議解決，均應以中華民國台灣法律為準據法，並依該法解釋。凡雙方因使用本服務或與本服務有關之一切糾紛、爭議或歧見，雙方同意先本誠信原則協商之，協商不成而涉訟時，雙方同意以台灣台北地方法院為第一審管轄法院。</li>
      </ol>
    </section>
  </div>
</template>
<style lang="scss" module>
  .title {
    @extend %typography-medium;

    margin-bottom: 1rem;
    font-weight: 500;
    color: $color-primary;
    text-transform: capitalize;
  }

  .titleBox {
    margin-bottom: 5rem;
  }

  .modalWrapper {
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    text-align: center;
    background: white;
    border-radius: $size-section-border-radius;
  }

  .modalClose {
    background-color: transparent;
    &:hover {
      background-color: transparent;
    }

    &::before,
    &::after {
      background-color: $grey;
    }

    &::after {
      height: 100%;
    }

    &::before {
      width: 100%;
    }
  }
</style>
<style lang="scss">
  .sectionArticle {
    p {
      margin-bottom: 0.75rem;
      text-align: justify;
    }
    ul {
      margin-bottom: 1rem;
    }
    li {
      margin-bottom: 0.25rem;
      line-height: 1.5rem;
      text-align: justify;
    }
    .isRowStyleA {
      padding-left: 1.2rem;
      > li {
        margin-bottom: 1rem;
      }
    }
    .isRowStyleB {
      padding-left: 1.5rem;
      text-indent: -1.5em;
    }
    .isRowStyleC {
      padding-left: 2.3rem;
      text-indent: -2.3rem;
    }
  }
</style>
